<template>
  <section class="content">
    <div v-if="!$gate.isType(['admin', 'editor'])">
        <not-found></not-found>
    </div>
    <div v-else class="container-fluid">
        <div class="row">

          <div class="col-12">
        
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">User List</h3>

                <div class="card-tools">
                  
                  <button type="button" class="btn btn-sm btn-primary" @click="newModal" v-if="$gate.isType('admin')">
                      <i class="fa fa-plus-square"></i>
                      Add New
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Type</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Created</th>
                      <th>Subscription</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="user in users.data" :key="user.id">

                      <td>{{user.id}}</td>
                      <td class="text-capitalize">{{user.type}}</td>
                      <td class="text-capitalize">{{user.name}}</td>
                      <td>{{user.email}}</td>
                      <td>{{user.created_at}}</td>
                      <td>
                        <div v-if="!['admin', 'editor'].includes(user.type) && user.main_subscription">
                            <p>
                                <strong>Status:</strong> 
                                <span class="text-danger" v-if="user.main_subscription.canceled_at">Cancelled</span>
                                <span class="text-warning" v-else-if="!user.main_subscription.is_active">Ended</span>
                                <span class="text-success" v-else>Active</span>
                            </p>
                            <span v-if="user.main_subscription.canceled_at"><strong>Canceled at:</strong> {{user.main_subscription.canceled_at | localDate}}<br></span> 
                            <strong>Plan:</strong> {{user.main_subscription.plan_id | plan_id}} <br>
                            <strong>Ends at:</strong> {{user.main_subscription.ends_at | localDate}} <br>
                        </div>
                        <div v-else-if="!['admin', 'editor'].includes(user.type) && !user.main_subscription">-No subscription-</div>
                      </td>

                      <td>

                        <a v-if="$gate.isType('admin')" @click="editModal(user)" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.update')" data-toggle="tooltip">
                            <i class="fa fa-edit blue"></i>
                        </a>
                        
                        <a v-if="$gate.isType('admin')" @click="deleteUser(user.id)" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.delete')" data-toggle="tooltip">
                            <i class="fa fa-trash red"></i>
                        </a>
                        
                        <router-link :to="'users/monitor/'+user.id" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.user_monitor')" data-toggle="tooltip">
                            <i class="fa fa-svg white">
                                <svg width="927pt" height="927pt" version="1.1" viewBox="-2 0 927 927.6" xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path d="m574.47 154.64v77.324c63.785 0 115.98 52.191 115.98 115.98h77.324c0-106.8-86.504-193.3-193.3-193.3z"/>
                                    <path d="m574.47 0v77.32c149.32 0 270.62 121.3 270.62 270.62h77.32c0-191.86-156.09-347.95-347.94-347.95z"/>
                                    <path d="m180.13 200.55c-14.98-14.977-39.625-14.977-54.605 0-166.24 165.76-167.21 434.93-1.4492 601.65 165.75 166.72 434.93 167.21 601.65 1.4531 0.48047-0.48438 0.96484-0.96484 1.4492-1.4531 14.98-14.977 14.98-39.625 0-54.605zm288.02 606.48c-21.262 0-38.66-17.395-38.66-38.656 0-21.266 17.398-38.664 38.66-38.664 21.266 0 38.664 17.398 38.664 38.664 0 21.262-17.402 38.656-38.664 38.656z"/>
                                    <path d="m622.31 348.42c3.3789-25.125-18.848-46.871-43.98-43.973l-197.65 28.027 213.12 213.11z"/>
                                </g>
                                </svg>
                            </i>
                        </router-link>

                        <router-link v-if="$gate.isType('admin') && !['admin', 'editor'].includes(user.type)" :to="'/users/subscription/'+user.id" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.manage')+' '+translate('messages.subscription')" data-toggle="tooltip">
                            <i class="fas fa-file-invoice-dollar" :class="$root.app_config.dark_mode ? 'white' : 'text-dark'"></i>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="users" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Create New User</h5>
                    <h5 class="modal-title" v-show="editmode">Update User's Info</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateUser() : createUser()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Name</label>
                            <input v-model="form.name" type="text" name="name"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input v-model="form.email" type="text" name="email"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                            <has-error :form="form" field="email"></has-error>
                        </div>
                    
                        <div class="form-group">
                            <label>Password</label>
                            <input v-model="form.password" type="password" name="password"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('password') }" autocomplete="false">
                            <has-error :form="form" field="password"></has-error>
                        </div>
                    
                        <div class="form-group">
                            <label>User Role</label>
                            <select name="type" v-model="form.type" id="type" class="form-control" :class="{ 'is-invalid': form.errors.has('type') }">
                                <option value="">Select User Role</option>
                                <option value="admin">Admin</option>
                                <option value="user">Standard User</option>
                                <option value="editor">Editor</option>
                            </select>
                            <has-error :form="form" field="type"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Update</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Create</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                editmode: false,
                users : {},
                form: new Form({
                    id : '',
                    type : '',
                    name: '',
                    email: '',
                    password: ''
                }),
                page : 1
            }
        },
        methods: {

            getResults(page = 1) {
                this.$Progress.start();
                this.page = page;
                axios.get('api/user?page=' + page).then(({ data }) => {
                    this.users = data.data;
                    this.$Progress.finish();
                });

            },
            updateUser(){
                this.$Progress.start();
                this.form.update({_method:'put'});
                this.form.post('api/user/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.getResults(this.page);
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },
            editModal(user){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(user);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },
            deleteUser(id){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {

                        // Send request to the server
                         if (result.value) {
                                this.form.delete('api/user/'+id).then(()=>{
                                        Swal.fire(
                                        'Deleted!',
                                        'Your file has been deleted.',
                                        'success'
                                        );
                                    // Fire.$emit('AfterCreate');
                                    this.getResults(this.page);
                                }).catch((data)=> {
                                  Swal.fire("Failed!", data.message, "warning");
                              });
                         }
                    })
            },          
          createUser(){
              this.form.update({_method:'post'});
              this.form.post('api/user')
              .then((response)=>{
                  $('#addNew').modal('hide');

                  Toast.fire({
                        icon: 'success',
                        title: response.data.message
                  });

                  this.$Progress.finish();
                  this.getResults(this.page);

              })
              .catch(()=>{

                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });
              })
          }

        },
        mounted() {

        },
        created() {

            this.$Progress.start();
            this.getResults();
            this.$Progress.finish();
        },
        filters: {
            plan_id: function (value) {
                switch(value){
                    case 1:
                        return 'Basic';
                    case 2:
                        return 'Professional';
                    case 3:
                        return 'Plus';
                    case 4:
                        return 'Agreement';
                    default:
                        return ''
                }
            }
        }
    }
</script>
